export const PATCH_RECEIVE_MESSEGASES_URL = 'v1/account/objects/:id/'
export type PatchReceiveMessagesReq = { receive_email_msg: boolean }

export const PATCH_SHOW_EMAIL_URL = 'v1/account/objects/:id/'
export type PatchShowEmailReq = { show_email: boolean }